module.exports = __webpack_public_path__ + "static/img/index.7f02958.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/dingtalk/index.png
// module id = ggqC
// module chunks = 1